import {
  DropDownDBFeatureInstance,
  TActivityHookInfo,
  TEditingEntity,
  TEntityLink,
  TLinkSource
} from "components/feature-entity-linking-page/models";
import { useMemo } from "react";
import MaterialListing from "./material-listing";
import SubmittalListing from "./submittal-listing";
import ActivityListing from "./activity-listing";

interface IListingWindowProps {
  editingEntity: TEditingEntity;
  onUpdateEditingEntityList: (props: { updatedlist: TLinkSource[] }) => void;
  setEditingEntity: React.Dispatch<React.SetStateAction<TEditingEntity | null>>;
  materials: Array<DropDownDBFeatureInstance>;
  submittals: Array<DropDownDBFeatureInstance>;
  activityListHook: TActivityHookInfo;
  selectedEntityInfo: TEntityLink | undefined;
}
function ListingLinkingWindow({
  editingEntity,
  onUpdateEditingEntityList,
  setEditingEntity,
  materials,
  submittals,
  activityListHook,
  selectedEntityInfo
}: IListingWindowProps) {
  const listingWindow = useMemo(() => {
    const feature = editingEntity.parentEntity
      ? editingEntity.parentEntity.rightFeatureDetail.feature
      : editingEntity.featureDetail.feature;
    switch (feature) {
      case "MATERIALS":
        return (
          <MaterialListing
            materials={materials}
            editingEntity={editingEntity}
            onUpdateEditingEntityList={onUpdateEditingEntityList}
            selectedEntityInfo={selectedEntityInfo}
          />
        );
      case "SUBMITTALS":
        return (
          <SubmittalListing
            submittals={submittals}
            onUpdateEditingEntityList={onUpdateEditingEntityList}
            editingEntity={editingEntity}
          />
        );
      case "SCHEDULES":
        return (
          <ActivityListing
            activityListHook={activityListHook}
            onUpdateEditingEntityList={onUpdateEditingEntityList}
            editingEntity={editingEntity}
            setEditingEntity={setEditingEntity}
            selectedEntityInfo={selectedEntityInfo}
          />
        );
      default:
        return null;
    }
  }, [
    editingEntity,
    materials,
    onUpdateEditingEntityList,
    submittals,
    activityListHook,
    setEditingEntity,
    selectedEntityInfo
  ]);

  return (
    <div className="linking-group--right h-full min-h-0 overflow-hidden">
      <div className="flex h-full min-h-0 w-full flex-col">{listingWindow}</div>
    </div>
  );
}

export default ListingLinkingWindow;
